module.exports = __webpack_public_path__ + "img/Flag_of_Finland.a814e980.svg";